import React from 'react';
import Loader from 'react-loader-spinner';
import { FiSearch, FiX } from 'react-icons/fi';
import { getPlayerImageUrl, getStadiumImageUrl, getTeamImageUrl } from '../constants/config';
import defaultAvatar from '../images/defaultAvatar.png';
import defaultTeamLogo from '../images/defaultTeamLogo.png';
import StadiumCrumbs from './StadiumCrumbs';

export function ReportPage({ title, message, children, tabs, activeTab, onTabChange }) {
  const hasTabs = Array.isArray(tabs) && tabs.length > 0;
  return (
    <div className="layoutWrapper st-layout rp-layout">
      <div className="matchCenterWrapper st-page rp-page">
        <div className="matchCenterHeader">
          <div className="st-header">
            <StadiumCrumbs items={[{ label: title }]} />
          </div>
        </div>
        {message ? <div className="st-message error">{message}</div> : null}
        {hasTabs ? (
          <div className="rp-tabs" role="tablist" aria-label={title}>
            {tabs.map((tab) => {
              const isActive = activeTab === tab.id;
              return (
                <button
                  key={tab.id}
                  type="button"
                  role="tab"
                  aria-selected={isActive}
                  className={`rp-tab${isActive ? ' is-active' : ''}`}
                  onClick={() => onTabChange?.(tab.id)}
                >
                  {tab.label}
                </button>
              );
            })}
          </div>
        ) : null}
        <div className={`rp-grid${hasTabs ? ' rp-grid--tabs' : ''}`}>
          {children}
        </div>
      </div>
    </div>
  );
}

export function ReportBlock({ title, filters, loading, error, children, tabId, tabActive }) {
  const tabClass = tabId
    ? (tabActive ? ' is-tab-active' : ' is-tab-hidden')
    : '';
  return (
    <section
      className={`st-block rp-block${tabClass}`}
      data-tab={tabId || undefined}
      role={tabId ? 'tabpanel' : undefined}
    >
      <h2 className="st-block-header">{title}</h2>
      {filters ? <div className="rp-filters">{filters}</div> : null}
      {error ? <div className="st-message error">{error}</div> : null}
      <div className="rp-scroll">
        {loading ? (
          <div className="rp-loader">
            <Loader type="TailSpin" color="#3ad1a0" height={28} width={28} />
          </div>
        ) : children}
      </div>
    </section>
  );
}

export function ReportDateRange({ from, to, onFrom, onTo, t, disabled }) {
  return (
    <div className="rp-dates">
      <label className="st-field">
        <span>{t('rpDateFrom')}</span>
        <div className="rp-native-dt">
          <input
            type="date"
            className="st-input"
            value={from}
            onChange={(event) => onFrom(event.target.value)}
            disabled={disabled}
          />
        </div>
      </label>
      <label className="st-field">
        <span>{t('rpDateTo')}</span>
        <div className="rp-native-dt">
          <input
            type="date"
            className="st-input"
            value={to}
            onChange={(event) => onTo(event.target.value)}
            disabled={disabled}
          />
        </div>
      </label>
    </div>
  );
}

export function ReportSearch({ value, onChange, placeholder, disabled }) {
  return (
    <div className="rp-search">
      <FiSearch className="rp-search-icon" />
      <input
        className="st-input rp-search-input"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        disabled={disabled}
      />
      {value ? (
        <button type="button" className="rp-search-clear" onClick={() => onChange('')} aria-label="clear">
          <FiX />
        </button>
      ) : null}
    </div>
  );
}

export function ReportThumb({ src, fallback, alt = '' }) {
  return (
    <img
      className="rp-thumb"
      src={src || fallback}
      alt={alt}
      onError={(event) => { event.currentTarget.src = fallback; }}
    />
  );
}

export function TeamThumb({ team, image }) {
  return (
    <ReportThumb
      src={getTeamImageUrl(team?.image || image)}
      fallback={defaultTeamLogo}
      alt={team?.name || ''}
    />
  );
}

export function PlayerThumb({ player }) {
  return (
    <ReportThumb
      src={getPlayerImageUrl(player?.image)}
      fallback={defaultAvatar}
      alt={player?.name || ''}
    />
  );
}

export function StadiumThumb({ stadium }) {
  return (
    <ReportThumb
      src={getStadiumImageUrl(stadium?.image)}
      fallback={defaultTeamLogo}
      alt={stadium?.name || ''}
    />
  );
}
